/**
 * Advanced Form Controls & Input's
 */
// Associate LMI Select2 controls with their visible labels and selections.
function fwLabelLmiSelect2($labels) {
  $labels.each(function () {
    var $label = jQuery(this);
    var $select = jQuery("#" + $label.attr("for"));
    var select2 = $select.data("select2");

    if (!select2) {
      return;
    }

    var $selection = select2.$container.find(".select2-selection");
    var valueId = $selection.find(".select2-selection__rendered").attr("id");

    $selection.attr(
      "aria-labelledby",
      $label.attr("id") + (valueId ? " " + valueId : "")
    );
  });
}
$(document).on("ready", function () {
  //SCHOLARSHIP HACK - must come before select2
  if ($("#overlay.scholarship-search").length) {
    var content = $("#overlay.scholarship-search #olWrap").html();
    addOverlay("scholarship-search", content);
  }

  //SELECT
  $('select, input.select:not(.search)').each(function(){
    if($(this).hasClass('notranslate')){
      var $select2 = $(this).select2();
      $select2.data('select2').$container.addClass("notranslate")
    }else {
      $(this).select2({});
    }
  });
  //console.log(31);
  $('select.search').select2({
    tags:true
  });
  //console.log(36);
   fwLabelLmiSelect2($(
     "#looking-ahead-location-label, #looking-ahead-category-label, " +
    "#now-trending-location-label, #now-trending-category-label, " +
    "#popular-places-category-label, #popular-places-occupation-label, " +
    "#loan-career-label" +
    "#scholarship-study-area-label, #scholarship-residence-label, " +
    "#scholarship-study-state-label"
  ));

  // Currency
  $(".currency").autoNumeric("init", {
    aSign: "$",
    mDec: 0,
    currencySymbolPlacement: "p",
    vMin: -9999999,
  });
});
